import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'cmps-card-body-next',
    template: ` <ng-content></ng-content>`,
    host: {
        class: 'cmps-card-body-next',
        '[class.cmps-card-body-next--collapsed-d-none]':
            '_collapsed && _collapseMethod === "d-none"',
        '[class.cmps-card-body-next--collapsed-v-hidden]':
            '_collapsed && _collapseMethod === "v-hidden"',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsCardBodyComponent {
    /** @private */
    _collapsed: boolean;

    /** @internal */
    // eslint-disable-next-line accessor-pairs
    set collapsed(value: boolean) {
        this._collapsed = value;
        this._changeDetectorRef.markForCheck();
    }

    /** @private */
    _collapseMethod: 'd-none' | 'v-hidden';

    /** @internal */
    // eslint-disable-next-line accessor-pairs
    set collapseMethod(value: 'd-none' | 'v-hidden') {
        this._collapseMethod = value;
        this._changeDetectorRef.markForCheck();
    }

    constructor(private readonly _changeDetectorRef: ChangeDetectorRef) {}
}
